export default {
    init() {
        const formArray = document.querySelectorAll('form[data-capture="form"]');

        const drawError = function (target, text) {
            const formError = document.getElementById(target).querySelector("[data-error='form-error']");
            if (formError) {
                formError.innerHTML = text;
                formError.classList.remove('hidden');
            }
        };

        const clearError = function (target) {
            const formError = document.getElementById(target).querySelector("[data-error='form-error']");
            if (formError) {
                formError.innerHTML = '';
                formError.classList.add('hidden');
            }
        };

        const getLocalStorage = function (localName) {
            const localStoreItem = window.localStorage.getItem(localName);
            return localStoreItem;
        };

        const storeLocal = function (parent) {
            const dataCapture = document.querySelectorAll(`#${parent} [data-capture]`);
            dataCapture.forEach((item) => {
                const dcName = (item.getAttribute('data-capture') !== null
                    && item.getAttribute('data-capture') !== undefined
                    && item.getAttribute('data-capture') !== '')
                    ? item.getAttribute('data-capture')
                    : item.getAttribute('name');
                window.localStorage.setItem(dcName, item.value);
            });
        };

        const checkEmail = function (target) {
            const emailAddy = document.getElementById(target).querySelector('[name="email"]').value;
            const emailDom = emailAddy.split('@')[1];
            const pattern = '(^hotmail|'
                + '^[gy]mail|'
                + '^googlemail|'
                + '^live|'
                + '^gmx|'
                + '^yahoo|'
                + '^outlook|'
                + '^msn|'
                + '^icloud|'
                + '^facebook|'
                + '^aol|'
                + '^zoho|'
                + '^mail|'
                + '^yandex|'
                + '^hushmail|'
                + '^lycox|'
                + '^lycosmail|'
                + '^inbox|'
                + '^myway|'
                + '^aim|'
                + '^fastmail|'
                + '^goowy|'
                + '^juno|'
                + '^shortmail|'
                + '^atmail|'
                + '^protonmail)'
                + '\\.';

            const flags = 'gim';

            const BANNED_EMAIL_REGEX = new RegExp(pattern, flags);
            const found = emailDom.match(BANNED_EMAIL_REGEX);
            return found;
        };

        const setInputFromLocalStorage = function (target) {
            const dcel = document.querySelectorAll(`[data-capture=${target}]`);
            const nel = document.querySelectorAll(`[name=${target}]`);
            if (dcel.length > 0) {
                dcel.forEach((item) => {
                    const localVal = getLocalStorage(item.getAttribute('data-capture')) ? getLocalStorage(item.getAttribute('data-capture')) : '';
                    item.setAttribute('value', localVal);
                });
            } else if (nel.length > 0) {
                nel.forEach((item) => {
                    const localVal = getLocalStorage(item.getAttribute('name')) ? getLocalStorage(item.getAttribute('name')) : '';
                    item.setAttribute('value', localVal);
                });
            }
        };

        formArray.forEach((thisForm) => {
            const submitButton = thisForm.querySelector('button[type="submit"]');
            const csrfInput = thisForm.querySelector('#csrfToken');
            thisForm.addEventListener('submit', (event) => {
                submitButton.disabled = true;
                const emailInvalid = checkEmail(thisForm.id);
                if (emailInvalid !== null) {
                    event.preventDefault();
                    submitButton.disabled = false;
                    drawError(thisForm.id, 'Please provide a valid business email address.');
                    return;
                }

                if (!csrfInput.value) {
                    event.preventDefault();
                    submitButton.disabled = false;
                    return;
                }

                clearError(thisForm.id);
                storeLocal(thisForm.id);
            });
        });

        /* Find all inputs with data-capture attribute */
        const dataCapture = document.querySelectorAll('input[data-capture]');
        dataCapture.forEach((item) => {
            const dc = (item.getAttribute('data-capture') !== null
            && item.getAttribute('data-capture') !== undefined
            && item.getAttribute('data-capture') !== '')
                ? item.getAttribute('data-capture')
                : item.getAttribute('name');
            setInputFromLocalStorage(dc);
        });
    },
};
